import React, { useEffect, useState } from "react";

import Menu from "../S1_Header/menu";
import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import {
  A,
  Bg,
  Hello,
  P,
  Position,
  SectionHeading,
  SectionSubHeading,
  SectionWrapper,
  Spanfollow,
} from "../../../styles";
import SlideBar from "../../../Componenets/SlideBar";
// import Loading from "./loading";

const Background = styled.div`
  background-image: url("/images/bg.png");
  min-height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  place-content: center;
  padding: 0 0 0 40px;
  @media screen and (max-width: 599px) {
    padding: 0;
  }
`;
const CustomGrid = styled(Grid)`
  align-items: center;
`;
const ImageGrid = styled(Grid)`
  text-align-last: center;
`;
const FeaturesImage = styled.img`
  width: 100%;
  height: auto;
  max-width:380px
`

const Index = () => {
  return (
    <div>
      <SlideBar />
      <Menu />
      <Background>
        <SectionWrapper>
          <Container maxWidth="xl">
            <SectionHeading p="20px 0">Features</SectionHeading>
            <CustomGrid container>
              <Grid xs={12} md={6}>
                <SectionSubHeading p="40px 0 0 0">
                  Burn volt inu
                </SectionSubHeading>
                <P maxWidth="80%">
                  HexVoltInu has an automated liquidity generation protocol that
                  allows the liquidity to gradually grow alongside the
                  token&apos;s trading volume.
                  <br />
                  Hex Volt Inu celebrates trailblazers in the crypto space. As
                  an homage to Volt Inu and Hex token, we will also be doing
                  manual buyback and burns of those tokens until we reach a 50k
                  and 100k market cap respectively.
                </P>
                {/* <TwoButtons>
                  <BuyNow>Buy Now</BuyNow>
                  <Chart>View Chart</Chart>
                </TwoButtons> */}
              </Grid>
              <ImageGrid xs={12} md={6}>
                <FeaturesImage
                  src="/images/featuresImg.png"
                />
              </ImageGrid>
            </CustomGrid>
          </Container>
        </SectionWrapper>
      </Background>
      {/* <Contract>Contract Address: TBA</Contract> */}
    </div>
  );
};

export default Index;
